import { LockClosedIcon, TrashIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import { CommentType } from "../../api/@types/globalTypes";
import moment from "moment";
import { useAuth } from "../../context/AuthContext";
import { makeApiRequest } from "../../helpers";
import { deleteSessionCommentData } from "../../api/endpoints/supervisors/sessions";
import { useParams } from "react-router-dom";
import { ApiResponse } from "../../api/apiResponse";
import { useState } from "react";
import ReportSessionModal from "../modal/DeleteSessionCommentModal";
import UserProfilePictureAvatar from "../avatar/UserProfilePictureAvatar";
type ReviewDescriptionPropsTypes = {
  comment: CommentType;
  refetch: any;
};

export default function ReviewDescription(props: ReviewDescriptionPropsTypes) {
  const LocalBasePath = "page.supervisor.sessions";
  const { comment, refetch } = props;
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { currentUser }: any = useAuth();
  const { id } = useParams();
  const [open, setOpen] = useState<boolean>(false);

  const getSessionComments = () => {
    makeApiRequest(
      () => deleteSessionCommentData(id ?? "", comment?.id),
      (res: ApiResponse) => {
        if (res.isSuccess) {
          refetch();
          setOpen(false);
        }
      }
    );
  };
  const deleteComment = () => {
    if (!comment.is_visible) {
      getSessionComments();
    } else {
      setOpen(true);
    }
  };
  return (
    <div className="w-full border-b border-gray-200 pt-2 pb-4">
      <div className="flex flex-col   gap-[14px] text-sm text-gray-500">
        <div className="w-full flex justify-between">
          <div className="flex gap-2 items-center">
            <UserProfilePictureAvatar
              profilePictureUrl={currentUser?.profile_picture_url}
              alt=""
              className="h-8 w-8 rounded-full bg-gray-100"
            />
            <div className="flex gap-1">
              <h3 className="font-medium text-sm text-gray-900">
                {currentUser?.firstName + " " + currentUser?.lastName}
              </h3>
              <p className="text-gray-400 text-xs leading-5">
                {moment(comment?.created_at).format("YYYY/MM/DD")}
                {"  "}
                {moment(comment?.created_at).format("HH:mm")}
              </p>
            </div>
          </div>
          <div className="p-4 cursor-pointer">
            <TrashIcon
              onClick={deleteComment}
              className="w-4 h-4 text-gray-400 "
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 rtl:pr-10 ltr:pl-10">
          <p className="  text-sm text-gray-500">{comment?.body}</p>
          {!comment.is_visible && (
            <div className="flex gap-1 items-center">
              <LockClosedIcon className="text-gray-500 w-6 h-6" />
              <p className="text-gray-500">{t("onlyMe")}</p>
            </div>
          )}
        </div>
      </div>
      <ReportSessionModal
        isOpen={open}
        onClose={(val) => {
          if (val) {
            getSessionComments();
          } else {
            setOpen(false);
          }
        }}
      />
    </div>
  );
}
